<template>
    <el-form ref="formRef" :disabled="saving" :rules="rules" :model="user" label-position="top">
        <el-form-item label="Nome" prop="name">
            <el-input type="text" v-model="user.name"  />
        </el-form-item>
        <el-form-item label="Bairo" prop="location">
            <el-input type="text" v-model="user.location"  />
        </el-form-item>
        <el-form-item label="Cargo" prop="role">
            <el-select v-model="user.role" placeholder="Selecione o tipo de conta">
                <el-option label="Administrador" value="admin" />
                <el-option label="Entregador" value="seller" />
            </el-select>
        </el-form-item>
        <el-form-item label="Numero de telefone" prop="phone">
            <el-input type="number" v-model="user.phone"  />
        </el-form-item>
        <el-form-item label="Senha de acesso" prop="password">
            <el-input type="password" v-model="user.password"  />
        </el-form-item>


        <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
            Cadastrar {{ {seller: 'Vendedor', admin: 'Administrador'}[user.role ?? 'seller'] }}
        </el-button>
    </el-form>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { User } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"
    import { useStore } from "vuex"

    const store = useStore()
    const user = reactive<User>({
        name: 'insira o nome',
        phone: 820000000,
        password: '',
        role: 'seller'
    })

    const rules = reactive<FormRules<User>>({
        name: [{required: true, message: 'Insira o nome', min: 1}],
        phone: [{required: true, message: 'Insira o número de telefone'}],
        password: [
            {required: true, message: 'Insira uma senha'},
            {min: 6, message: 'Pelo menos 6 caracteres'},
        ],
        location: [{required: true, message: 'Insira o bairo'}]
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post('admin/users', user)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Vendedor cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                    // router.push('/sellers')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
